export enum ViewMode {
  Student = 1
}

export enum AssessmentType {
  Formatives = 'formatives',
  Benchmarks = 'benchmarks',
  Assignments = 'assignments'
}
